module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-5-4833cf879081a5f640472e28dc787de7.jpg";